var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinterFenceMRCone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 32,
    viewBox: "0 0 20 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76117 31.3024C14.9315 31.3024 19.1229 28.5422 19.1229 25.1373C19.1229 21.7325 14.9315 18.9723 9.76117 18.9723C4.59082 18.9723 0.399414 21.7325 0.399414 25.1373C0.399414 28.5422 4.59082 31.3024 9.76117 31.3024Z",
    fill: "#A06A38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1229 6.18567H0.399414V24.9092H19.1229V6.18567Z",
    fill: "#A06A38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76117 12.579C14.9315 12.579 19.1229 9.81883 19.1229 6.41396C19.1229 3.00909 14.9315 0.248901 9.76117 0.248901C4.59082 0.248901 0.399414 3.00909 0.399414 6.41396C0.399414 9.81883 4.59082 12.579 9.76117 12.579Z",
    fill: "#CB8E5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinterFenceMRCone);
export default __webpack_public_path__ + "static/media/winter_fence_m_r_cone.72a250b42d72219d25235c5f278ff1af.svg";
export { ForwardRef as ReactComponent };